var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmphoraLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M325.147 191.378C320.746 216.682 286.896 228.102 243.314 233.162C158.839 242.975 37.7645 228.878 23.3115 245.762C37.7705 225.731 88.9799 221.729 145.435 220.018H145.682C221.788 217.678 307.342 219.419 325.141 191.372L325.147 191.378Z",
    fill: "url(#paint0_linear_1124_1788)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M492.137 215.961C418.474 234.724 354.527 178.025 243.876 187.273C216.079 189.597 127.582 220.537 127.582 220.537C149.32 207.192 225.584 181.881 243.49 179.714C259.585 177.765 321.848 168.324 395.958 190.045H395.994C402.415 191.94 408.921 194.046 415.499 196.431C463.079 213.619 492.137 215.961 492.137 215.961Z",
    fill: "url(#paint1_linear_1124_1788)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M492.138 216.208C463.292 248.658 393.666 235.684 334.931 233.404C316.627 232.682 299.391 232.989 284.772 236.039C337.711 211.547 395.029 219.113 437.233 222.373H437.251C462.146 224.286 481.777 224.731 492.138 216.202V216.208Z",
    fill: "url(#paint2_linear_1124_1788)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5273 244.791C66.7998 257.97 50.2447 257.988 36.7989 257.731C28.5455 257.578 21.4513 257.321 19 259.949C22.2422 247.291 41.9067 244.05 56.4755 243.805C63.4489 243.688 69.2571 244.258 71.5273 244.797V244.791Z",
    fill: "url(#paint3_linear_1124_1788)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M325.147 191.378C320.743 216.605 286.879 227.991 243.279 233.035C208.999 234.644 195.969 218.701 145.613 219.937C221.751 217.598 307.34 219.334 325.147 191.372V191.378Z",
    fill: "url(#paint4_linear_1124_1788)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M396.098 190.047C349.28 182.699 308.529 176.198 243.934 187.269C216.123 189.593 127.582 220.537 127.582 220.537C149.337 207.196 225.639 181.882 243.554 179.715C259.657 177.765 321.952 168.322 396.098 190.047Z",
    fill: "url(#paint5_linear_1124_1788)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M437.258 222.266C402.147 221.63 391.814 234.287 334.94 233.26V233.278C316.633 232.557 299.394 232.864 284.772 235.908C337.72 211.459 395.047 219.012 437.258 222.266Z",
    fill: "url(#paint6_linear_1124_1788)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M448.627 243.869C478.742 240.159 491.589 227.237 491.589 227.237C495.284 242.618 489.51 254.951 448.627 243.869Z",
    fill: "url(#paint7_linear_1124_1788)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M425.194 335.946L465.209 268.119H480.713L492.131 335.946H477.989L474.951 319.621H450.125L440.488 335.946H425.194ZM454.63 308.668H475.266L470.657 281.389L454.63 308.668Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M367.346 335.946L381.592 268.119H413.96C421.083 268.119 426.181 270.19 429.254 274.333C432.396 278.405 433.199 283.917 431.663 290.868C430.755 295.432 428.8 299.399 425.797 302.77C422.864 306.14 419.023 308.492 414.274 309.826C415.182 310.739 415.846 311.722 416.265 312.775C416.754 313.829 417.172 315.233 417.522 316.988L421.712 335.946H407.047L402.856 317.726C402.507 316.181 401.984 315.093 401.285 314.461C400.587 313.829 399.26 313.513 397.305 313.513H386.201L381.487 335.946H367.346ZM388.715 301.717H403.275C406.977 301.717 410.049 300.909 412.494 299.294C414.938 297.609 416.544 294.8 417.312 290.868C418.15 287.077 417.976 284.303 416.788 282.548C415.671 280.792 412.982 279.915 408.723 279.915H393.324L388.715 301.717Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M324.377 337C314.042 337 306.605 334.156 302.065 328.469C297.526 322.711 296.479 314.004 298.923 302.349C301.577 289.92 306.081 280.933 312.436 275.386C318.861 269.839 327.799 267.065 339.252 267.065C349.867 267.065 357.374 269.839 361.774 275.386C366.243 280.933 367.151 289.92 364.497 302.349C362.053 314.004 357.619 322.711 351.194 328.469C344.769 334.156 335.83 337 324.377 337ZM326.996 324.888C333.351 324.888 338.379 323.062 342.08 319.411C345.782 315.689 348.47 310.002 350.146 302.349C351.403 296.521 351.822 291.922 351.403 288.551C351.054 285.181 349.692 282.794 347.318 281.389C344.944 279.915 341.382 279.178 336.633 279.178C330.278 279.178 325.215 280.933 321.444 284.444C317.743 287.884 315.02 293.852 313.274 302.349C311.668 310.283 311.807 316.04 313.693 319.621C315.648 323.132 320.083 324.888 326.996 324.888Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M224.232 335.946L238.479 268.119H252.62L246.649 296.556H276.084L282.055 268.119H296.197L281.95 335.946H267.809L273.78 307.509H244.345L238.374 335.946H224.232Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M161.628 335.946L175.874 268.119H206.671C211.839 268.119 215.959 269.207 219.032 271.384C222.174 273.49 224.304 276.334 225.422 279.915C226.539 283.426 226.644 287.287 225.736 291.5C224.269 298.381 221.266 303.963 216.727 308.247C212.258 312.53 205.973 314.671 197.872 314.671H180.169L175.769 335.946H161.628ZM182.578 303.402H196.72C201.189 303.402 204.576 302.348 206.881 300.242C209.255 298.065 210.791 295.151 211.49 291.5C212.328 287.568 212.153 284.584 210.966 282.548C209.849 280.441 206.985 279.388 202.376 279.388H187.711L182.578 303.402Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6328 335.946L95.879 268.119H109.601L120.81 308.878L149.198 268.119H163.863L149.617 335.946H135.475L144.798 291.816L122.172 324.256H114.001L105.097 291.816L95.7743 335.946H81.6328Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3232 335.946L37.5694 268.119H85.9646L83.6601 279.178H49.4064L45.7401 296.556H76.118L73.8135 307.509H43.4355L39.7692 324.993H74.023L71.7184 335.946H23.3232Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1124_1788",
    x1: 23.8538,
    y1: 215.795,
    x2: 324.63,
    y2: 221.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F78F6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36B56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1124_1788",
    x1: 274.941,
    y1: 207.464,
    x2: 476.478,
    y2: 249.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37F65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D56555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1124_1788",
    x1: 358.479,
    y1: 230.358,
    x2: 487.756,
    y2: 223.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF775E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E3221"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1124_1788",
    x1: 44.5786,
    y1: 245.769,
    x2: 46.0342,
    y2: 259.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1124_1788",
    x1: 145.806,
    y1: 209.764,
    x2: 20.7746,
    y2: 207.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C85B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A84C40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1124_1788",
    x1: 128.028,
    y1: 196.698,
    x2: 395.909,
    y2: 201.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB725A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB4E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1124_1788",
    x1: 346.37,
    y1: 226.048,
    x2: 429.262,
    y2: 243.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE755A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1624F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1124_1788",
    x1: 448.499,
    y1: 238.412,
    x2: 492.593,
    y2: 237.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B60A27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmphoraLoader);
export default __webpack_public_path__ + "static/media/emphora_loader.abc4219c47b5c8711af038c039bd6142.svg";
export { ForwardRef as ReactComponent };